import useCandidateStatuses from '@/hooks/useCandidateStatuses';
import { getFormattedStatus, getStatusColor } from '@/utils/format';
import * as Styles from './StatusTag.styles';

export type StatusTagProps = {
  status: string | { value: string };
  colored?: boolean;
  outlined?: boolean;
  statusColor?: string;
  className?: string;
};

const StatusTag = ({
  status,
  colored,
  outlined,
  statusColor,
  ...props
}: StatusTagProps): JSX.Element => {
  const candidateStatuses = useCandidateStatuses();
  const statusToUse = typeof status === 'string' ? status : status.value;
  const statusLabel = getFormattedStatus(statusToUse);
  const statusColorToUse = statusColor || getStatusColor(statusToUse, candidateStatuses);

  return (
    <div {...props}>
      <Styles.Status outlined={outlined} colored={colored} statusColor={statusColorToUse}>
        {/* This is necessary to solve a problem with the font alignment caused by the typography that we use */}
        <span className="placeholder">{statusLabel}</span>
        <span className="displayed">{statusLabel}</span>
      </Styles.Status>
    </div>
  );
};

export default StatusTag;
